import { render, staticRenderFns } from "./detail-mobile-app.vue?vue&type=template&id=451a748c&"
import script from "./detail-mobile-app.vue?vue&type=script&lang=js&"
export * from "./detail-mobile-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports